export default "__VITE_ASSET__D7QnZWNS__"